<script setup lang="ts">
import { computed } from 'vue'
import { FormBuilder } from './index'

const props = defineProps<{
    context: any
}>()

const modelValue = computed<string | undefined>({
    get: () => {
        const val = props.context?.value
        if (!val) { return undefined }
        return typeof val === 'string' ? val : JSON.stringify(val)
    },
    set: (json: string | undefined) => {
        props.context?.node.input(json || null)
    },
})
</script>

<template>
    <FormBuilder v-model="modelValue" />
</template>
